export default {
  hytj:'ລວບລວມຂໍ້ມູນການຂົນສົ່ງສິນຄ້າ',
  tjhz:'ສະຫຼຸບຂໍ້ມູນ',
  qb:'ທັງໝົດ',
  fh:'ກັບຄືນ',
  sh:'ຮັບສິນຄ້າ',
  tjfs:'ວິທີການເກັບກໍາສະຖິຕິ',
  jyn:'ໃນໄລຍະ1ປີ',
  jyy:'ໃນໄລຍະ1ເດືອນ',
  tjsjjzzr:'ສັງລວມຂໍ້ມູນຮອດມື້ວານ',
  hwzz:'ນ້ຳໜັກລວມທັງໝົດຂອງສິນຄ້າ',
  wd:'ສິນພັນ ໂຕນ',
  tb:'ສົມທຽບໃສ່ປີຜ່ານມາໃນເວລາດຽວກັນ',
  hb:'ສົມທຽບໃສ່ເດືອນທີ່ຜ່ານມາໃນເວລາດຽວກັນ',
  fhhwzz:'ນໍ້າໜັກລວມໃນການຈັດສົ່ງສິນຄ້າ',
  shhwzz:'ນໍ້າໜັກລວມໃນການຮັບສິນຄ້າ',
  ljxf:'ການໃຊ້ຈ່າຍທັງໝົດ',
  wy:'ໝື່ນຢວນ',
  my: 'ໂດລາ',
  jp: 'ກີບ',
  zjfhjj:'ໄລຍະເວລາການສົ່ງສິນຄ້າຄັ້ງຫຼ້າສຸດ ເຖິງປັດຈຸບັນ',
  zjshjj:'ໄລຍະເວລາການຮັບເອົາສິນຄ້າຄັ້ງຫຼ້າສຸດ ເຖິງປັດຈຸບັນ',
  tian:'ວັນ',
  fwqy:'ວິສາຫະກິດ ບໍລິການ',
  zysfhwpl:'ປະເພດສິນຄ້າຕົ້ນຕໍທີ່ຮັບເຂົ້າແລະຈັດສົ່ງ',
  dw:'ຫົວໜ່ວຍ',
}
